define("CCAW.FloatingContactUs.Button.View", [
    "SCView",
    "underscore",
    "ccaw_floating_contact_us_button.tpl",
    "CCAW.FloatingContactUs.Modal.View",
], function (
    SCViewModule,
    _,
    ccaw_floating_contact_us_button_tpl,
    CCAWFloatingContactUsModalView
) {
    "use strict";

    var SCView = SCViewModule.SCView;

    function CCAWFloatingContactUsButtonView(options) {
        SCView.call(this);

        this.options = options || {};
        this.config = this.options.config || {};
        this.template = ccaw_floating_contact_us_button_tpl;

        this.events = {
            'click [data-action="open-contact-us-modal"]': "openModal",
        };
    }

    CCAWFloatingContactUsButtonView.prototype = Object.create(SCView.prototype);
    CCAWFloatingContactUsButtonView.prototype.constructor = CCAWFloatingContactUsButtonView;

    CCAWFloatingContactUsButtonView.prototype.openModal = function openModal(e) {
        var layout;
        var modalView;

        if (e) {
            e.preventDefault();
        }

        layout = this.options.container.getComponent("Layout");

        if (!layout) {
            return;
        }

        modalView = new CCAWFloatingContactUsModalView({
            container: this.options.container,
            config: this.config,
            pageHeader: this.config.modalTitle,
        });

        layout.showContent(modalView, { showInModal: true }).then(function () {
            modalView.loadJotformForm();
        });
    };

    CCAWFloatingContactUsButtonView.prototype.getContext = function getContext() {
        var hasDesktopImage = !_.isEmpty(this.config.desktopImageUrl);
        var hasMobileImage = !_.isEmpty(this.config.mobileImageUrl);

        return {
            buttonAltText: this.config.buttonAltText || "Contact Us",
            buttonLabel: this.config.buttonAltText || "Contact Us",
            desktopImageUrl: this.config.desktopImageUrl || "",
            mobileImageUrl: this.config.mobileImageUrl || "",
            hasDesktopImage: hasDesktopImage,
            hasMobileImage: hasMobileImage,
            showFallbackLabel: !hasDesktopImage && !hasMobileImage,
            useDesktopImageOnMobile: hasDesktopImage && !hasMobileImage,
            useMobileImageOnDesktop: !hasDesktopImage && hasMobileImage,
        };
    };

    return CCAWFloatingContactUsButtonView;
});
